import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import LatestTracking from './components/LatestTracking';
import CTASection from './components/CTASection';
import ReviewSection from './components/ReviewSection';
import { categories } from '@/mocks/articles';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '51今日吃瓜网',
      url: 'https://www.51chigua.com',
      description: '全网最新吃瓜资源与爆料入口，实时更新明星博主塌房现场、网红黑料、每日大赛等热门事件，聚合吃瓜视频和黑料追踪。',
      foundingDate: '2024',
    },
    {
      '@type': 'WebSite',
      name: '51今日吃瓜网',
      url: 'https://www.51chigua.com',
      description: '全网最新吃瓜资源与爆料入口',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.51chigua.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '51今日吃瓜网 - 全网最新吃瓜资源与爆料入口',
      description: '51今日吃瓜网提供全网最新吃瓜资源与爆料入口，实时更新明星博主塌房现场、网红黑料、每日大赛等热门事件，聚合吃瓜视频和黑料追踪，是吃瓜群众必看的信息集散地。',
      url: 'https://www.51chigua.com/',
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: categories.map((cat, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: cat.name,
          url: `https://www.51chigua.com/category/${cat.slug}`,
        })),
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="51今日吃瓜网 - 全网最新吃瓜资源与爆料入口"
        description="51今日吃瓜网提供全网最新吃瓜资源与爆料入口，实时更新明星博主塌房现场、网红黑料、每日大赛等热门事件，聚合吃瓜视频和黑料追踪，是吃瓜群众必看的信息集散地。"
        keywords="51今日吃瓜网,51吃瓜网站,51吃瓜爆料,51吃瓜黑料,51吃瓜每日大赛,51吃瓜在线观看,51吃瓜视频,51今日吃瓜官网,51吃瓜网址,51吃瓜黑料网,51吃瓜官网全网最新,51吃瓜网在线观看"
        canonicalUrl="/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <LatestTracking />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}